window.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll('[data-section-type="slideshow"]')
    .forEach((section) => {
      let carousel = section.querySelector(".Slideshow__Carousel");

      if (!carousel) return;

      let flkty = Flickity?.data(carousel);

      if (!flkty) return;
      const btns = section?.querySelectorAll(".Slideshow__Nav");
      btns?.forEach((item) => {
        let prevBtn = item?.querySelector(".Slideshow__Prev");
        let nextBtn = item?.querySelector(".Slideshow__Next");

        if (!prevBtn || !nextBtn) return;

        prevBtn.addEventListener("click", () => {
          flkty.previous();
          flkty.playPlayer();
        });

        nextBtn.addEventListener("click", () => {
          flkty.next();
          flkty.playPlayer();
        });
      });
    });
});
